import { Participant } from "../model/participant";

export class UpdateParticipantDto {
  participant: Participant;
}